import { render } from "./TargetText.vue?vue&type=template&id=6ce031ea&scoped=true&ts=true"
import script from "./TargetText.vue?vue&type=script&lang=ts"
export * from "./TargetText.vue?vue&type=script&lang=ts"

import "./TargetText.vue?vue&type=style&index=0&id=6ce031ea&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ce031ea"]])

export default __exports__